<div class="flex flex-col ">
    <!-- Header -->
    <div mat-dialog-title class="flex flex-0 items-center justify-between h-12 p-0">
        <div class="flex flex-col justify-center text-center text-lg font-medium">Service Fee / Adjustment <small>Itinerary Reference AG-124250-1</small></div>
        <button mat-icon-button (click)="close()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <mat-dialog-content class="grid p-0">
        <div class="mt-10 rounded-lg">
            <!-- <div class="mt-10 text-center font-bold">Capture Payment</div> -->
            <div class="">
                <div class="flex flex-col gap-4">
                    <!-- Dropdown for Method -->
                    <select
                        name="method"
                        [(ngModel)]="view.fee.serviceSelected"
                        class="block w-full rounded-md border border-slate-300 bg-white px-3 py-4 font-semibold text-gray-500 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500 sm:text-sm"
                    >
                        <option value="" disabled selected class="text-gray-400 font-semibold">
                            Select Type *
                        </option>
                        <option value="price-beat">Price Beat</option>
                        <option value="discount">Discount</option>
                        <option value="adjustment">Adjustment</option>
                        <option value="exchange-rate-change">Exchange rate change</option>
                        <option value="other">Other</option>
                    </select>


                    <input type="text" name="service"  *ngIf="view.fee.serviceSelected == 'other'" [(ngModel)]="view.fee.service"
                        class="block w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm placeholder:font-semibold placeholder:text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500 sm:text-sm"
                        placeholder="service..." />
                    <input type="number" name="amount"   [(ngModel)]="view.fee.cost"
                    class="block w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm placeholder:font-semibold placeholder:text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500 sm:text-sm"
                    placeholder="Amount *" />
                </div>

                <!-- Message Textarea -->
                <div class="mt-6">
                    <textarea name="textarea" id="text" cols="30" rows="10" [(ngModel)]="view.fee.internalNote" placeholder="Enter note"
                        class="mb-10 h-40 w-full resize-none rounded-md border border-slate-300 p-4 font-semibold text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500">Message</textarea>
                </div>

            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <div class="flex justify-center">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-button cdkFocusInitial (click)="saveCustomItemToItin(data.itinerary.guid, view.fee)">Apply</button>
        </div>
    </mat-dialog-actions>
</div>
